exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-container[data-v-9edc0b4e]{padding-top:150px}.loading-container img[data-v-9edc0b4e]{margin:auto;display:-webkit-box;display:-ms-flexbox;display:flex}.message[data-v-9edc0b4e]{padding-left:40%}", ""]);

// exports
